export function Founders({ texts }: any) {
  return (
    <section id="founders" className="bg-lxmt-bg py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap -mx-4 mb-10">
          <div className="w-full lg:w-12/12 px-4 mb-8 lg:mb-0">
            <div className="text-center">
              <h5 className="text-lg text-[#e04f39] uppercase mb-4">
                {texts.title}
              </h5>
              <h1 className="text-5xl font-black mb-8">{texts.subtitle}</h1>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-center -mx-4">
          {texts.founders.map((item: any) => (
            <div className="w-full lg:w-4/12 px-4 mb-8 lg:mb-0">
              <div className="bg-xsdn-bg p-8 rounded-lg shadow-lg">
                <div className="text-center">
                  <img
                    src={item.photo}
                    alt={item.name}
                    className="w-1/2 mx-auto rounded-full mb-4"
                  />
                  <h2 className="text-2xl font-bold mb-2">{item.name}</h2>
                  <p className="text-lg text-gray-600 mb-4">{item.specialty}</p>
                  <hr className="border-t border-gray-300 my-10" />
                  <p className="text-lg text-gray-600 mb-4">{item.infos}</p>
                  <a
                    href={item.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-500 hover:text-blue-700 transition duration-300 ease-in-out"
                  >
                    <i className="fab fa-linkedin fa-lg mr-2 text-[#303133]"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Founders;
